import { render, staticRenderFns } from "./Scored.vue?vue&type=template&id=8ae9cdb4"
import script from "./Scored.vue?vue&type=script&lang=js"
export * from "./Scored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports